import {call, takeLatest, put} from "redux-saga/effects"
import {
    CREATE_SUPPORT_TICKET,
    createSupportTicketFailureAction,
    createSupportTicketSuccessAction
} from "../commonActions";
import {createTicket} from "../../../api/support";

function* processCreateSupportTicketSaga({payload}) {
    try {
        const ticket = payload.ticket
        yield call(createTicket, {ticket})
        yield put(createSupportTicketSuccessAction())
    } catch (err) {
        console.log(err)
        yield put(createSupportTicketFailureAction())
    }
}

export function* watchCreateSupportTicket() {
    yield takeLatest(CREATE_SUPPORT_TICKET, processCreateSupportTicketSaga)
}
